module.exports = __webpack_public_path__ + "img/unicorn-book_B0979QQS6C.580ad4a5.jpg";